import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Header from '../components/molecule/Header';
import Footer from '../components/molecule/Footer';
import Wrapper from '../components/atoms/Wrapper';
import Headline from '../components/atoms/Headline';
import Copy from '../components/atoms/Copy';
import ImageWithText from '../components/molecule/ImageWithText';
import ButtonAsLink from '../components/atoms/ButtonAsLink';
import HeroImage from '../components/molecule/HeroImage';

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-4xs);
`;

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: var(--distance-xxl);
`;

const StyledWrapper = styled(Wrapper)`
  padding-bottom: 0;
`;

const IndexPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header />
      <StyledWrapper>
        <StyledHeadline label={t('microsite.headline')} />
        <Copy>
          <Trans t={t} i18nKey="microsite.introduction">
            Erlebe die Geschichte von CAMEL auf deinem Pack: Wie du auf der CAMEL Heritage-Edition
            die Story unserer Marke wiederfindest, zeigen wir dir hier!
          </Trans>
        </Copy>
        <HeroImage target="#scrollToTarget" />
        <ImageWithText
          id="scrollToTarget"
          ratio={'1/1'}
          srcYellow={t('microsite.components.1.image.srcYellow')}
          srcBlue={t('microsite.components.1.image.srcBlue')}
          imgSrcSmallYellow={t('microsite.components.1.image.imgSrcSmallYellow')}
          imgSrcSmallBlue={t('microsite.components.1.image.imgSrcSmallBlue')}
          alt={t('microsite.components.1.image.alt')}
          label={
            <Trans t={t} i18nKey="microsite.components.1.text">
              CAMEL hat eine lange Tradition, die sich schon über 110 Jahre bewährt hat: 1913 kam
              das erste CAMEL-Pack auf den Markt.
            </Trans>
          }
        />
        <ImageWithText
          ratio={'1/1'}
          srcYellow={t('microsite.components.2.image.srcYellow')}
          srcBlue={t('microsite.components.2.image.srcBlue')}
          imgSrcSmallYellow={t('microsite.components.2.image.imgSrcSmallYellow')}
          imgSrcSmallBlue={t('microsite.components.2.image.imgSrcSmallBlue')}
          alt={t('microsite.components.2.image.alt')}
          seperator={true}
          label={
            <Trans t={t} i18nKey="microsite.components.2.text">
              Seit Gründung der Marke steht CAMEL für hochwertigen Tabak mit Premium-Geschmack.
              Deswegen heben wir hier die Tabakblätter hervor.
            </Trans>
          }
        />
        <ImageWithText
          ratio={'1/1'}
          srcYellow={t('microsite.components.3.image.srcYellow')}
          srcBlue={t('microsite.components.3.image.srcBlue')}
          imgSrcSmallYellow={t('microsite.components.3.image.imgSrcSmallYellow')}
          imgSrcSmallBlue={t('microsite.components.3.image.imgSrcSmallBlue')}
          alt={t('microsite.components.3.image.alt')}
          seperator={true}
          label={
            <Trans t={t} i18nKey="microsite.components.3.text">
              Die CAMEL-Wüstenlandschaft ist hier mit der Linien-Schraffur dargestellt, die
              charakteristisch für die ersten Packs war.
            </Trans>
          }
        />
        <ImageWithText
          ratio={'1/1'}
          srcYellow={t('microsite.components.4.image.srcYellow')}
          srcBlue={t('microsite.components.4.image.srcBlue')}
          imgSrcSmallYellow={t('microsite.components.4.image.imgSrcSmallYellow')}
          imgSrcSmallBlue={t('microsite.components.4.image.imgSrcSmallBlue')}
          alt={t('microsite.components.4.image.alt')}
          seperator={true}
          label={
            <Trans t={t} i18nKey="microsite.components.4.text">
              Pinsel und Stift stehen für die kreative Ader, die die Marke CAMEL von 1913 an bis
              heute begleitet.
            </Trans>
          }
        />
        <ImageWithText
          ratio={'629/798'}
          srcYellow={t('microsite.components.5.image.srcYellow')}
          srcBlue={t('microsite.components.5.image.srcBlue')}
          imgSrcSmallYellow={t('microsite.components.5.image.imgSrcSmallYellow')}
          imgSrcSmallBlue={t('microsite.components.5.image.imgSrcSmallBlue')}
          alt={t('microsite.components.5.image.alt')}
          seperator={false}
          label={
            <Trans t={t} i18nKey="microsite.components.5.text">
              Viel Spaß mit deinem Pack! Alles über die Marke CAMEL sowie spannende Artikel und
              tolle Aktionen findest du in unserer Community{' '}
              <a
                rel="nofollow"
                href="https://lets-cml.de/?utm_source=microsite&utm_medium=anchor&utm_campaign=lep_enduring_icon"
              >
                lets-cml.de
              </a>
              . Schau doch mal vorbei!
            </Trans>
          }
        />
        <StyledButtonContainer>
          <ButtonAsLink
            link={t('microsite.components.6.link')}
            label={t('microsite.components.6.label')}
          />
        </StyledButtonContainer>
        <Copy>
          <Trans t={t} i18nKey="microsite.components.8.text">
            Du willst gern noch mehr über CAMELs Heritage-Story erfahren? Kein Problem. Die ganze
            Geschichte gibt’s in unserem aktuellen Blog-Artikel auf{' '}
            <a
              rel="nofollow"
              href="https://www.lets-cml.de/enduring-icon?utm_source=microsite&utm_medium=link&utm_campaign=lep_enduring_icon"
            >
              lets-cml.de/enduring-icon
            </a>
            .
          </Trans>
        </Copy>
        <StyledButtonContainer>
          <ButtonAsLink
            link={t('microsite.components.7.link')}
            label={t('microsite.components.7.label')}
          />
        </StyledButtonContainer>
      </StyledWrapper>
      <Footer />
    </>
  );
};

export default IndexPage;
